// getVodPlayerPoolSizeMaxKey.js
'use strict';

import {
  VOD_PLAYER_POOL_SIZE_DESKTOP_MAX,
  VOD_PLAYER_POOL_SIZE_MOBILE_MAX,
} from '../RemoteConfigKeys.js';
import { getIsOnMobile } from '../resource/getUserAgent.js';

/**
 * Pick the pool-size key for this device. The pool max and the Shorts mount
 * window must resolve to the same number, so every consumer asks here rather
 * than deciding on its own (a UA check and a viewport width disagree on
 * tablets). The name is both the remote config key and the build-time env var;
 * outside Redux read it off `resource/env.js`, never `process.env` — see
 * playerPool.js.
 * @returns {string} Remote config key / env var name for this device.
 * @example
 * getRemoteConfigData(state, getVodPlayerPoolSizeMaxKey());
 * env[getVodPlayerPoolSizeMaxKey()];
 */
const getVodPlayerPoolSizeMaxKey = () =>
  getIsOnMobile()
    ? VOD_PLAYER_POOL_SIZE_MOBILE_MAX
    : VOD_PLAYER_POOL_SIZE_DESKTOP_MAX;

export default getVodPlayerPoolSizeMaxKey;
